<template>
  <ReflectionTableCard>
    <template #header>Recomended sessions</template>
    <template #subheader>Based on your learner profile</template>
    <template #content>
      <table class="min-w-full divide-y divide-gray-200">
        <tbody>
          <tr
            v-for="(item, itemIdx) in this.itemsList"
            :class="itemIdx % 2 === 0 ? 'bg-white' : 'bg-gray-50'"
            :key="item.id"
          >
            <td class="pl-6 py-4 whitespace-nowrap text-xs font-medium text-vice-teal-900">
              {{ item.title }}
            </td>
            <td class="">
              <a :href="item.href" class="text-gray-500 hover:text-gray-400">
                <ChevronRightIcon class="h-4 w-4"></ChevronRightIcon>
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </template>
  </ReflectionTableCard>
</template>

<script>
import { ChevronRightIcon } from '@heroicons/vue/solid';
import ReflectionTableCard from './Components/ReflectionTableCard.vue';

export default {
  name: 'RecommendedSessions',
  data() {
    return {
      itemsList: [
        { id: 1, title: 'Genetics Clinic', href: '#' },
        { id: 2, title: 'MSK Clinic', href: '#' },
        { id: 3, title: 'GP home visit', href: '#' },
      ],
    };
  },
  components: { ReflectionTableCard, ChevronRightIcon },
};
</script>

<style scoped></style>

RecommendedSessions
